import {lazy} from 'react';

import type {RouteConfig} from '../types';

import {Loadable} from '../components/Loadable';
import {SpinnerFallback} from '../components/SpinnerFallback';
import {yourSpaceRoutesPath} from './path';

const DashboardPage = Loadable(
  lazy(
    () =>
      import('@src/pages/Dashboard' /* webpackChunkName: "dashboard-page" */),
  ),
);

// TABS
const ContactsTab = Loadable(
  lazy(() =>
    import(
      '@src/v2/modules/contacts' /* webpackChunkName: "contacts-tab" */
    ).then(module => ({default: module.Contacts})),
  ),
  <SpinnerFallback />,
);
const MyFinancesTab = Loadable(
  lazy(
    () =>
      import(
        '@src/modules/MyFinances/MyFinances' /* webpackChunkName: "my-finances-tab" */
      ),
  ),
  <SpinnerFallback />,
);
const MyJoinedProgramsTab = Loadable(
  lazy(
    () =>
      import(
        '@src/modules/MyJoinedPrograms/MyJoinedPrograms' /* webpackChunkName: "my-joined-programs-tab" */
      ),
  ),
  <SpinnerFallback />,
);
const MyLibraryTab = Loadable(
  lazy(
    () =>
      import(
        '@src/modules/MyLibrary/MyLibrary' /* webpackChunkName: "my-library-tab" */
      ),
  ),
  <SpinnerFallback />,
);
const MyNotesTab = Loadable(
  lazy(
    () => import('@src/modules/MyNotes' /* webpackChunkName: "my-notes-tab" */),
  ),
  <SpinnerFallback />,
);
const MyServicesTab = Loadable(
  lazy(
    () =>
      import(
        '@src/modules/MyServices/MyServices' /* webpackChunkName: "my-services-tab" */
      ),
  ),
  <SpinnerFallback />,
);
const PracticeTab = Loadable(
  lazy(
    () =>
      import(
        '@src/modules/MySquads/MySquads' /* webpackChunkName: "practice-tab" */
      ),
  ),
  <SpinnerFallback />,
);
const MyToolboxTab = Loadable(
  lazy(
    () =>
      import(
        '@src/modules/MyToolbox/MyToolbox' /* webpackChunkName: "my-toolbox-tab" */
      ),
  ),
  <SpinnerFallback />,
);

const TrackersPage = Loadable(
  lazy(() =>
    import(
      '@src/v2/pages/TrackersPage' /* webpackChunkName: "trackers-page" */
    ).then(module => ({default: module.TrackersPage})),
  ),
);
const AssessmentDetailsPage = Loadable(
  lazy(() =>
    import(
      '@src/v2/pages/AssessmentDetails' /* webpackChunkName: "assessment-details-page" */
    ).then(module => ({default: module.AssessmentDetails})),
  ),
);

export const yourSpaceRoutes = [
  {
    children: [
      {
        element: <ContactsTab />,
        path: yourSpaceRoutesPath.contacts.$path(),
      },
      {
        element: <MyFinancesTab />,
        path: yourSpaceRoutesPath.finances.$path(),
      },
      {
        element: <MyJoinedProgramsTab />,
        path: yourSpaceRoutesPath.joinedPrograms.$path(),
      },
      {
        element: <MyLibraryTab />,
        path: yourSpaceRoutesPath.library.$path(),
      },
      {
        element: <MyNotesTab />,
        path: yourSpaceRoutesPath.notes.$path(),
      },
      {
        element: <MyServicesTab />,
        path: yourSpaceRoutesPath.services.$path(),
      },
      {
        element: <PracticeTab />,
        path: yourSpaceRoutesPath.practice.$path(),
      },
      {
        element: <MyToolboxTab />,
        path: yourSpaceRoutesPath.toolbox.$path(),
      },
    ],
    element: <DashboardPage />,
    path: yourSpaceRoutesPath.$path(),
  },
  {
    element: <AssessmentDetailsPage />,
    path: yourSpaceRoutesPath.toolbox.assessment.$path(),
  },
  {
    element: <TrackersPage />,
    path: yourSpaceRoutesPath.toolbox.trackers.$path(),
  },
] satisfies RouteConfig[];
